export interface StatisticEntryModel {
  date: string;
  entries: { name: string; value: number }[];
}

export interface AllStatisticsModel {
  entryPoints: string[];
  data: StatisticEntryModel[];
}

// TODO: DELETE THIS AFTER BE IS READY
export const statisticsDataMock: AllStatisticsModel = {
  entryPoints: [
    'allVersions',
    'android9',
    'android10',
    'android12',
    'android13',
  ],
  data: [
    {
      date: '2022-02-21',
      entries: [
        { name: 'allVersions', value: 910 },
        { name: 'android9', value: 210 },
        { name: 'android10', value: 260 },
        { name: 'android12', value: 320 },
        { name: 'android13', value: 120 },
      ],
    },
    {
      date: '2022-02-22',
      entries: [
        { name: 'allVersions', value: 1000 },
        { name: 'android9', value: 230 },
        { name: 'android10', value: 280 },
        { name: 'android12', value: 360 },
        { name: 'android13', value: 130 },
      ],
    },
    {
      date: '2022-02-23',
      entries: [
        { name: 'allVersions', value: 970 },
        { name: 'android9', value: 220 },
        { name: 'android10', value: 270 },
        { name: 'android12', value: 340 },
        { name: 'android13', value: 140 },
      ],
    },
    {
      date: '2022-02-24',
      entries: [
        { name: 'allVersions', value: 1090 },
        { name: 'android9', value: 240 },
        { name: 'android10', value: 310 },
        { name: 'android12', value: 390 },
        { name: 'android13', value: 150 },
      ],
    },
    {
      date: '2022-02-25',
      entries: [
        { name: 'allVersions', value: 1110 },
        { name: 'android9', value: 260 },
        { name: 'android10', value: 330 },
        { name: 'android12', value: 360 },
        { name: 'android13', value: 160 },
      ],
    },
    {
      date: '2022-02-26',
      entries: [
        { name: 'allVersions', value: 1230 },
        { name: 'android9', value: 250 },
        { name: 'android10', value: 350 },
        { name: 'android12', value: 410 },
        { name: 'android13', value: 220 },
      ],
    },
    {
      date: '2022-02-27',
      entries: [
        { name: 'allVersions', value: 1320 },
        { name: 'android9', value: 270 },
        { name: 'android10', value: 360 },
        { name: 'android12', value: 430 },
        { name: 'android13', value: 260 },
      ],
    },
    {
      date: '2022-02-28',
      entries: [
        { name: 'allVersions', value: 1340 },
        { name: 'android9', value: 260 },
        { name: 'android10', value: 380 },
        { name: 'android12', value: 420 },
        { name: 'android13', value: 280 },
      ],
    },
    {
      date: '2022-03-01',
      entries: [
        { name: 'allVersions', value: 1430 },
        { name: 'android9', value: 280 },
        { name: 'android10', value: 390 },
        { name: 'android12', value: 460 },
        { name: 'android13', value: 300 },
      ],
    },
    {
      date: '2022-03-02',
      entries: [
        { name: 'allVersions', value: 1460 },
        { name: 'android9', value: 290 },
        { name: 'android10', value: 410 },
        { name: 'android12', value: 440 },
        { name: 'android13', value: 320 },
      ],
    },
    {
      date: '2022-03-03',
      entries: [
        { name: 'allVersions', value: 1525 },
        { name: 'android9', value: 285 },
        { name: 'android10', value: 430 },
        { name: 'android12', value: 470 },
        { name: 'android13', value: 340 },
      ],
    },
  ],
};
